import { BRAND_RESOURCES } from '@/constants/brand-resources';
import { electronLog } from '@laigu/utils/electron';

const logo = BRAND_RESOURCES.favicon;
const customizedLogoUrl = window.CUSTOM_CONFIG && window.CUSTOM_CONFIG[window.CUSTOM_NAME].logo;
const customizedLogoImg = customizedLogoUrl && require(`static/img/${customizedLogoUrl}`);

let allow = false;
let notification;

function documentClick() {
  const clickEvent = document.createEvent('MouseEvents');
  clickEvent.initEvent('mousedown', true, true);
  document.dispatchEvent(clickEvent);
  const mask = document.getElementsByClassName('mq-modal-mask')[0];
  if (mask) {
    mask.click();
  }
}

const checkPermission = () => {
  if (window.Notification) {
    if (Notification.permission === 'granted') {
      allow = true;
    } else {
      Notification.requestPermission(status => {
        // 请求权限
        allow = status === 'granted';
      });
    }
  }
};

const createNotification = async opts => {
  let options = opts;
  if (window.isElectron) {
    const { ipcRenderer, windowId, versionCode } = window.electron;
    let config = window.electron.config;
    // 针对客户端 versionCode 11 开始的版本，每次获取一下最新配置，解决在客户端更改配置后不立即生效的问题
    if (versionCode != null && versionCode >= 11) {
      config = await ipcRenderer.invoke('getConfig');
    }
    // 任务栏图标闪烁
    if (config.onNewMessage === 'flash') {
      ipcRenderer.send('flash', windowId);
    }
    // 激活窗口
    if (config.onNewMessage === 'focus') {
      ipcRenderer.send('focus-window', windowId);
    }

    if (!config.showNotification) {
      electronLog('!config.showNotification = true');
      return;
    }
  }
  if (options.mine) {
    electronLog('createNotification allow: ' + allow);
  }

  if (allow) {
    options = {
      title: window.customized.name,
      icon: customizedLogoImg || logo,
      body: 'notify!',
      onclick: () => {},
      ...options
    };

    // Notification API 的 body 参数为字符串，去掉消息内容中的 HTML 标签
    options.body = options.body && options.body.replace(/<\/?[^>]+(>|$)/g, '').replace(/(&nbsp;)/g, '');

    if (notification) {
      notification.close();
      notification = null;
    }

    notification = new Notification(options.title, {
      body: options.body,
      icon: options.icon
    });

    if (options.mine) {
      electronLog(`createNotification title: ${options.title}`);
    }

    if (options.mine) {
      notification.onshow = () => {
        electronLog(`notification onshow title: ${options.title}`);
      };
      notification.onclose = () => {
        electronLog(`notification onclose title: ${options.title}`);
      };
    }

    notification.onclick = () => {
      if (window.isElectron) {
        const { ipcRenderer, windowId } = window.electron;
        ipcRenderer.send('click-notification', windowId);
      }
      window.focus();
      documentClick();
      options.onclick();
      notification.close();
    };

    let timeout = 15000;

    // win10 客户端通知弹窗消失时间设置少一些
    if (window.isElectron && window.navigator.userAgent.indexOf('Windows NT 10') !== -1) {
      timeout = 3000;
    }
    // 5秒后关闭通知
    setTimeout(() => notification.close(), timeout);
  }
};

export default {
  checkPermission,
  createNotification
};
